import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class WidgetService extends ApiService {

  public getNbReferences(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/widgets/nb_references`)
  }

  public getNbStocks(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/widgets/nb_stocks`)
  }

  public getRepartitionSecteur(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/widgets/repartition_secteur`)
  }

  public getRepartitionEtat(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/widgets/repartition_etat`)
  }
}